import EmptyItems from "@shared/components/EmptyItems";
import React from "react";

const OverviewPage: React.FC = () => <EmptyItems />;
export default OverviewPage; 